import { useQuery, useQueryClient, useMutation } from "react-query";
import { Box, Heading, Spinner, useToast } from "@chakra-ui/react";

// local imports
import { getAllDocs, deleteList } from "../services/firebase";
import Lists from "../components/Lists";
import CreateListForm from "../components/CreateListForm";

const Dashboard = ({ user }) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const deleteMutation = useMutation((docId) => deleteList(docId), {
    onMutate: async (docId) => {
      await queryClient.cancelQueries("lists");
      const oldLists = queryClient.getQueryData("lists");
      // optimistic update
      queryClient.setQueryData("lists", (oldLists) =>
        oldLists.filter((list) => list.id !== docId)
      );

      return { oldLists };
    },
    onError: (error, docId, context) => {
      // if query fails, use old lists data
      queryClient.setQueryData("lists", context.oldLists);
    },
    onSettled: () => {
      queryClient.invalidateQueries("lists");
    },
  });

  const {
    data: lists,
    error,
    isLoading,
  } = useQuery("lists", () => getAllDocs(user.uid));

  const handleDelete = async (docId) => {
    deleteMutation.mutate(docId);
    toast({
      position: "top",
      title: "A list was deleted",
      isClosable: true,
      duration: 3000,
      status: "warning",
    });
  };

  if (isLoading) {
    return (
      <Box textAlign="center">
        <Spinner thickness="4px" color="teal.500" size="lg" />
      </Box>
    );
  }

  if (error) {
    return <Heading textAlign="center">{error}</Heading>;
  }

  return (
    <Box>
      <CreateListForm uid={user.uid} />

      {lists && lists.length === 0 ? (
        <Box pt={8} textAlign="center">
          <Heading size="md">You've no lists, start by creating one.</Heading>
        </Box>
      ) : (
        <Lists lists={lists} handleDelete={handleDelete} />
      )}
    </Box>
  );
};

export default Dashboard;
